import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsWebauthnComponent } from './simple-icons-webauthn.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsWebauthnComponent ],
    exports:      [ SimpleIconsWebauthnComponent ],
    bootstrap:    []
})
export class SimpleIconsWebauthnModule {}
